export const SUBSCRIPTION_STATUS = {
  expired: 'EXPIRED',
  canceled: 'CANCELED',
  active: 'ACTIVE',
};

export const SUBSCRIPTION = {
  annual: 'annual',
  seasonal: 'seasonal',
  trial: 'trial',
};

export const PLAN_CODE = {
  ffftrial: 'ffftrial',
  fffvip: 'fffvip',
  fffvipa: 'fffvipa',
};

export const getUserSubscriptionStatus = (subscriptionState) => {
  if (subscriptionState === 'active') {
    return {
      SUBSCRIPTION_STATE: subscriptionState,
      COLOR: 'green',
    };
  }
  if (subscriptionState === 'expired') {
    return {
      SUBSCRIPTION_STATE: subscriptionState,
      COLOR: 'red',
    };
  }
  if (subscriptionState === 'canceled') {
    return {
      SUBSCRIPTION_STATE: subscriptionState,
      COLOR: 'grey',
    };
  }
  return {
    SUBSCRIPTION_STATE: subscriptionState,
    COLOR: 'green',
  };
};
